module.exports = __webpack_public_path__ + "static/media/decorativeThread.785437a2.png";